<template>
    <div>
        <div class="top_header">
            <div class="title">编辑帖子</div>
            <van-icon name="cross" @click="close"/>
        </div>
        <Form :model="actionData" class="topic_form" @submit.native.prevent>
            <FormItem>
                <div class="flex">
                    <data-select url="tool/app-game-list" show-loading :limit="0" style="width: 70%">
                        <i-select placeholder="选择版块" slot-scope="scope" v-model="actionData.gameId">
                            <Option v-for="{ id, game_name } of scope.data" :key="id" :value="id" :label="game_name">
                            </Option>
                        </i-select>
                    </data-select>

                    <data-select key="tag" v-if="actionData.gameId" url="tool/game-topic-tag-list"
                        :params="{ game_id: actionData.gameId }" :limit="0" style="margin-left: 8px; width: 30%">
                        <i-select placeholder="帖子类型" slot-scope="scope" v-model="actionData.tagId">
                            <Option v-for="{ id, tag_name } of scope.data" :key="id" :value="id" :label="tag_name">
                            </Option>
                        </i-select>
                    </data-select>
                </div>
            </FormItem>
            <FormItem prop="title">
                <i-input type="text" :placeholder="`请输入标题(`+ minLenght+`~`+maxLength+`字）`" :minlenght="this.minLenght"
                    :maxlength="this.maxLength" v-model="actionData.title" key="title" />
            </FormItem>
            <FormItem prop="discussId">
                <div class="choose_discuss" @click="openPop"><b>+</b>&nbsp;选择话题</div>
                <div class="choose_discuss_name" v-for="(item,i) in lastResult" :key="i" v-if="lastResult.length > 0">
                    #{{item.discuss_name}}#
                    <Icon class="delete_discuss_name" type="ios-close-circle-outline"
                        @click="deleteDiscussName(item.id)" />
                </div>
                <div class="choose_discuss_popup" v-if="popShow">
                    <div class="bg"></div>
                    <div class="discuss_popup_content">
                        <Icon type="ios-close-circle-outline" @click="popShow = false" />
                        <i-input prefix="ios-search" placeholder="搜索话题" v-model="keyword" />
                        <topic-scroll url="com/discuss" :params="params" :limit="10000" :text="''" :text2="'暂无话题哦~'"
                            ref="discuss" id="discuss_popup_list">
                            <template slot-scope="sope">
                                <van-checkbox-group v-model="result" :max="3">
                                    <van-checkbox icon-size="18px" checked-color="#670000" v-for="(row,i) in sope.data"
                                        :key="i" class="panel_discuss" :name="row.id" ref="checkboxes"
                                        @click="changeChoose(i,row.discuss_name)">
                                        <div class="right">
                                            <div class="l1">
                                                #{{row.discuss_name}}#
                                                <Tag class="official_tag" color="#2d8cf0" v-if="row.is_official == 1">官方
                                                </Tag>
                                            </div>
                                            <div class="l2">{{row.discuss_comment_nums}}人在讨论</div>
                                        </div>
                                    </van-checkbox>
                                </van-checkbox-group>
                            </template>
                        </topic-scroll>
                        <div class="discuss_popup_bottom">
                            <div v-if="!tipsShowFlag"></div>
                            <div class="tips" v-if="tipsShowFlag">最多选择3个</div>
                            <Button type="success" @click="confirm">确定</Button>
                        </div>
                    </div>
                </div>
            </FormItem>
            <FormItem prop="content">
                <div id="editor">
                    <bbcode-editor ref="editor" :content="actionData.content" />
                </div>
            </FormItem>
            <FormItem class="no_bottom">
                <van-button :loading="loading1" class="cg" native-type="button" @click.stop="saveToRough">
                    <Icon type="md-document" />保存到草稿</van-button>
            </FormItem>
        </Form>
        <div class="btns_bottom">
            <van-button class="cancel" @click="close">取消</van-button>
            <van-button class="create_topic_btn" :loading="loading2" @click="publish">发表</van-button>
        </div>
    </div>
</template>
<script>
    import $ from "jquery";
    export default {
        data() {
            return {
                minLenght: 5,
                maxLength: 40,
                actionData: {
                    topicId: this.selection.id,
                    gameId: this.selection.game_id,
                    tagId: this.selection.tag_id,
                    title: this.selection.title,
                    content: this.selection.content,
                    attachments: this.selection.attachments,
                    rough: 1
                },
                discussId: this.selection.discussId || '',
                chooseResult: this.selection.discuss || [],
                lastResult: this.selection.discuss || [],
                loading1: false,
                loading2: false,
                popShow: false,
                result: [],
                tipsShowFlag: false,
                params: {
                    type: 'all',
                },
                keyword: '',
                timer: null,
            };
        },
        computed: {
            isiOS() {
                var u = navigator.userAgent;
                if (!!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
                    return true
                } else {
                    return false
                }
            },
        },
        created() {

        },
        mounted() {
            this.showForm = true
        },
        methods: {
            close() {
                this.$emit('closeModal')
            },
            //打开话题
            openPop() {
                this.result = []
                this.lastResult.forEach(e => {
                    this.result.push(e.id);
                });
                this.popShow = true;
            },
            //删除话题
            deleteDiscussName(id) {
                this.result = this.result.filter(item => {
                    return item.id != id
                })
                this.lastResult = this.lastResult.filter(item => {
                    return item.id != id
                })
            },
            // 选择话题
            changeChoose(i, discussName) {
                if (this.result.length >= 3) {
                    this.tipsShowFlag = true;
                }
                if (this.$refs.checkboxes[i].checked) {
                    this.chooseResult.push({
                        id: this.$refs.checkboxes[i].name,
                        discuss_name: discussName,
                    });
                } else {
                    this.chooseResult = this.chooseResult.filter(item => {
                        return item.id != this.$refs.checkboxes[i].name;
                    });
                }
            },
            //确定选择话题
            confirm() {
                this.lastResult = []
                this.chooseResult.map(item => {
                    this.result.find(i => {
                        if (item.id == i) {
                            this.lastResult.push(item)
                        }
                    })
                })
                let obj = {}
                this.lastResult = this.lastResult.reduce((cur, next) => {
                    obj[next.id] ? '' : obj[next.id] = true && cur.push(next)
                    return cur
                }, [])
                this.popShow = false
            },
            _validate() {
                if (this.lastResult.length > 0) {
                    this.actionData.discussId = this.lastResult.map(item => item.id).join(',')
                } else {
                    this.actionData.discussId = ''
                }
                this.actionData.content = this.$refs.editor.gethtml()
                const {
                    gameId,
                    tagId,
                    title,
                    content
                } = this.actionData;
                const html = content
                const brhtml = html.replace('<br>', '').replace(/\s*/g, '')
                if (gameId == '') {
                    this.$toast('请选择版块')
                    return false
                }
                if (tagId == '') {
                    this.$toast('请选择帖子类型')
                    return false
                }
                if (title == '') {
                    this.$toast('请输入标题')
                    return false
                } else {
                    if (title.length < this.minLenght || title.length > this.maxLength) {
                        this.$toast('标题长度请控制在' + this.minLenght + '~' + this.maxLength + '字')
                        return false
                    } else {
                        if (brhtml == '') {
                            this.$toast('请输入帖子内容')
                            return false
                        } else {
                            this.beforeSubmit()
                            return true
                        }
                    }
                }

            },
            // 提交前解析content内的图片追加到attachments
            beforeSubmit() {
                const html = this.$refs.editor.getcode()
                var result = html.match(/\[img\]([^[]+)\[\/img\]/g)
                var arr = []
                if (result) {
                    for (var i = 0; i < result.length; i++) {
                        arr.push(result[i].match(/\[img\]([^[]+)\[\/img\]/)[1])
                    }
                    this.actionData.attachments = arr.join(",");
                } else {
                    this.actionData.attachments = ''
                }
            },
            // 保存到草稿
            saveToRough() {
                var that = this
                this.actionData.rough = 1
                if (this._validate()) {
                    this.loading1 = true
                    this.$Ajax('topic/create-topic', this.actionData).then(rs => {
                        if (rs.code == 200) {
                            this.$toast(rs.msg)
                            this.$emit("success");
                        }
                    }).finally(() => {
                        setTimeout(() => {
                            that.loading1 = false
                        }, 2000)
                    })
                }
            },
            publish() {
                var that = this
                this.actionData.rough = 0
                if (this._validate()) {
                    this.loading2 = true
                    this.$Ajax('topic/create-topic', this.actionData).then(rs => {
                        if (rs.code == 200) {
                            this.$toast(rs.msg)
                            this.$emit("success");
                        }
                    }).finally(() => {
                        setTimeout(() => {
                            that.loading2 = false
                        }, 2000)
                    })
                }
            }
        },
        watch: {
            keyword: {
                immediate: true,
                handler(k) {
                    var that = this;
                    if (that.timer) {
                        clearTimeout(that.timer);
                    }
                    that.timer = setTimeout(() => {
                        var o = {
                            keyword: k
                        };
                        that.params = {
                            ...that.params,
                            ...o,
                        };
                        if(that.popShow) {
                            that.$refs.discuss.refresh()
                        }
                    }, 1000);
                },
            },
            result: {
                immediate: true,
                handler(r) {
                    if (r.length > 0) {
                        this.actionData.discussId = r.toString()
                    } else {
                        if (this.discussId) {
                            this.actionData.discussId = this.discussId
                        }
                    }
                }
            },
            'selection.discuss': {
                immediate: true,
                handler(a) {
                    if (a) {
                        a = a.map(item => {
                            return item.id
                        })
                        this.actionData.discussId = a.toString()
                    }

                }
            }
        }
    }
</script>
<style lang="less" scoped>
    .top_header {
        position: fixed;
        top: 0;
        width: 100%;
        height: 2.4rem;
        line-height: 2.4rem;
        background-color: #fff;
        z-index: 100;
        font-size: 0.8rem;
        border-bottom: 1px solid #eee;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .75rem;

        .title {
            font-size: .6385rem;
            font-weight: 700;
        }

        .van-icon {
            font-size: .8rem;
            color: #000;
            font-weight: 700;
            cursor: pointer;
        }
    }

    .topic_form {
        margin: 3.15rem .75rem 2.4rem;
        padding: 0.8rem;
        background-color: #fff;
        border-radius: .7rem;

        .ivu-form-item {
            border-bottom: 1px solid #dcdee2;
            margin-bottom: 0.8rem;
            padding-bottom: 0.8rem;

            &.no_bottom {
                border: none;
                padding-bottom: 0;
            }

            .cg {
                font-size: 0.6rem;
                padding: 0;
                width: 5rem;
                height: 1.6rem;
                line-height: 1.6rem;
                border-radius: 0.2rem;
                background-color: #19be6b;
                color: #fff;
                border-color: #19be6b;

                .ivu-icon-md-document {
                    margin-bottom: 0.1rem;
                    margin-right: 0.2rem;
                }
            }
        }
    }

    .btns_bottom {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 3.35rem;
        display: flex;
        align-items: flex-start;
        justify-content: flex-end;
        padding: 0.5rem;
        border-top: 1px solid #eee;
        background-color: #fff;

        .van-button {
            padding: 0;
            width: 3.9rem;
            height: 1.6rem;
            line-height: 1.6rem;
            border-radius: 0.2rem;
            margin-left: 0.5rem;
            border-radius: 10rem;
        }

        .cancel {
            border: none;
        }

        .create_topic_btn {
            background-color: #670000;
            color: #fff;
            font-size: .7rem;
        }
    }

    .already_choose {
        color: #670000;
        display: inline-block;
        border: 1px dashed #670000;
        line-height: 24px;
        padding: 0 6px;
        margin: 4px 6px;
    }

    .choose_discuss {
        display: inline-block;
        padding: 0 12px;
        background-color: #e3e4e7;
        border-radius: 50px;
        cursor: pointer;
        margin: 4px 0;
    }

    .choose_discuss_name {
        color: #670000;
        display: inline-block;
        border: 1px dashed #670000;
        line-height: 24px;
        padding: 0 6px;
        margin: 4px 6px;
        position: relative;

        .delete_discuss_name {
            position: absolute;
            font-size: 14px;
            top: -8px;
            right: -8px;
            color: #333333;
            cursor: pointer;
            background-color: #fff;
        }
    }

    .choose_discuss_popup {
        .bg {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 20000;
            background-color: rgba(0, 0, 0, 0.4);
        }

        .discuss_popup_content {
            position: fixed;
            top: 140px;
            left: 50%;
            width: 86%;
            max-width: 460px;
            transform: translateX(-50%);
            background-color: #fff;
            z-index: 20001;
            border-radius: 6px;
            padding: 16px;

            .ivu-icon-ios-close-circle-outline {
                font-size: 26px;
                color: #fff;
                position: absolute;
                top: -22px;
                right: -22px;
                cursor: pointer;
            }

            .ivu-input-wrapper {
                margin-bottom: 12px;
            }

            #discuss_popup_list {
                max-height: 300px;
                overflow-y: auto;

                .panel_discuss {
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    padding: 6px 0;
                    border-bottom: 1px solid #dcdee2;

                    &.checked {
                        background-color: red;
                    }

                    &:active {
                        opacity: 0.9;
                    }

                    .left {
                        width: 40px;
                        height: 40px;
                        margin-right: 6px;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 6px;
                        }
                    }

                    .right {
                        flex: 1;

                        .l1,
                        .l2 {
                            line-height: 16px;
                        }

                        .l1 {
                            color: #670000;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-inline-box;
                            -webkit-line-clamp: 1;
                            -webkit-box-orient: vertical;
                            position: relative;
                            padding-right: 12px;
                            height: 22px;

                            .official_tag {
                                transform: scale(0.75);
                                transform-origin: 0 center;
                                line-height: 20px;
                                margin-left: 6px;

                                &:hover {
                                    opacity: 1;
                                }

                                &:active {
                                    opacity: 1;
                                }
                            }
                        }

                        .l2 {
                            font-size: 12px;
                            transform: translateY(-2px);
                            color: #9e9e9e;
                        }
                    }
                }
            }

            .ivu-page {
                margin-bottom: 0;
            }
        }
    }

    .discuss_popup_bottom {
        padding-top: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .tips {
            color: red;
        }
    }
</style>